/**
 * Alaska: App.js (PWA)
 * Data: Authentication
 * @version 1.0
 */
document.addEventListener("alpine:init", () => {
    Alpine.data("Auth", () => ({
        user: "",
        password: "",
        loading: false,
        error: "",
        show_password: false,

        login() {
            this.loading = true;
            this.error = "";

            if (this.user === ".")
            {
                this.error = "Your account setup is incomplete. Please contact Xtra Logistics."
                this.loading = false;
                return;
            }

            const form = new FormData();
            form.append("action", "login");
            form.append("controller", "authentication");
            form.append("user", this.user);
            form.append("password", this.password);

            fetch("/", {
                method: "POST",
                body: form
            })
                .then(res => res.json())
                .then(async (json) => {
                    this.loading = false;

                    if (json.type === "success") {
                        Alpine.store("user").logged_in = true;

                        // Wait until ready
                        await Alpine.store("user").init();

                        Alpine.store("state").load("dashboard", "index");
                    } else {
                        this.error = json.message || "Login failed.";
                    }
                })
                .catch(error => {
                    this.loading = false;
                    this.error = "Something went wrong.";
                    console.error(error);
                });
        },

        logout() {
            this.loading = true;

            fetch("/", {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    action: "logout",
                    controller: "authentication"
                })
            })
                .then(res => res.json())
                .then(json => {
                    this.loading = false;
                    if (json.type === "success") {
                        Alpine.store("user").logout();

                        Alpine.store("state").history = [];
                        Alpine.store("state").load();
                    } else {
                        this.error = json.message || "Logout failed.";
                    }
                })
                .catch(error => {
                    this.loading = false;
                    this.error = "Something went wrong.";
                    console.error(error);
                });
        }

    }));
});